import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import PrivateAgenda from './pages/PrivateAgenda';
import Wedding from './pages/Wedding';
import Reception from './pages/Reception';
import Invitation from './pages/Invitation';
import MainAgenda from './pages/MainAgenda';
import SangeetNWedding from './pages/SangeetNWedding';
import CreateLink from './pages/CreateLink';
import FullAgenda from './pages/FullAgenda';
import CompactAgenda from './pages/CompactAgenda';
import Timeline from './pages/Timeline';
import CombinedAgenda from './pages/CombinedAgenda';
import SangeetWeddingReception from './pages/SangeetWeddingReception';
import AdminAccess from './pages/AdminAccess';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/prxivtaeagnd7283" element={<PrivateAgenda />} />
        <Route path="/cweerdedmionngy" element={<Wedding />} />
        <Route path="/rfeucnecpttiioonn" element={<Reception />} />
        <Route path="/wiendvdiitnagtion" element={<Invitation />} />
        <Route path="/maagiennda" element={<MainAgenda />} />
        <Route path="/swaendgdeientg" element={<SangeetNWedding />} />
        <Route path="/crtlnk9472xwz" element={<CreateLink />} />
        <Route path="/fllagnd8293kxm" element={<FullAgenda />} />
        <Route path="/cmpctgnd5628vqr" element={<CompactAgenda />} />
        <Route path="/tmlne4739hjk" element={<Timeline />} />
        <Route path="/cmbndgnd8392plw" element={<CombinedAgenda />} />
        <Route path="/sngwdrcp8472mjk" element={<SangeetWeddingReception />} />
        <Route path="/admin" element={<AdminAccess />} />
        <Route path="*" element={<div style={{textAlign: 'center', marginTop: '50px', fontSize: '48px'}}>ERROR: Page Not Found </div>} />
      </Routes>
    </Router>
  );
}

export default App;